import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Box } from '@mui/material';

import RevenueMapModal from '../components/reports/RevenueMapModal';

/**
 * Stand-alone landing page for the revenue map, reachable through the key-login
 * deep link (e.g. /authentication/<key>/omzetkaart). It simply hosts the existing
 * RevenueMapModal opened on top of an empty backdrop; closing it returns home.
 */
const RevenueMapScreen = (props) => {
    const navigate = useNavigate();
    const [open, setOpen] = useState(true);

    useEffect(() => {
        props.changeScreen && props.changeScreen('reports');
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    return (
        <Box sx={{ width: '100%', height: '100%' }}>
            <RevenueMapModal
                open={open}
                onClose={() => { setOpen(false); navigate('/' + props.lang + '/home'); }}
                api={props.api}
                sftUserId={props.sftUserId}
                t={props.t}
                lang={props.lang}
                theme={props.theme}
                screenWidth={props.screenWidth}
                notify={props.notify}
            />
        </Box>
    );
};

export default RevenueMapScreen;
